export default __webpack_public_path__ + "static/media/20-Update-Your-Handbook.0dd9331d.jpg";